window.productCustom = function () {
    $("#preview-product").insertBefore( $( ".tee-form-action .tee-btn--preview" ) );
    $("#preview-product").click(function (){
        console.log('testestest')
        openPreview()
    })
    $('#preview-atc').click(function (){
        $('#teeAtcButton').click()
        closePreview()
    })
    $('.close-preview').click(function (){
        closePreview()
    })
    function openPreview () {
        if($('.tee-slide--active .tee-mockup').length > 0){
            $('#custom-preview').addClass('active')
            $('.preview-container').html('')
            $('.tee-slide--active .tee-mockup').clone().appendTo('.preview-container')
        }
    }
    function closePreview() {
        $('#custom-preview').removeClass('active')
    }
}
$(document).ready(function (){
    $('.tabs-list a').click(function(e){
        e.preventDefault();
        let id = $(this).attr('data-href');
        $('.tabs-list a').removeClass('active');
        $('.booster--revert').removeClass('active');
        $(this).addClass('active');
        $(id).addClass('active');
    })
    $('.product-tab__title').click(function(){
        $(this).toggleClass('active')
        $(this).next().slideToggle()
    })
    function waitATC($currentBtn) {
        const $button = $('#teeAtcButton')
        if($button.hasClass('tee-processing')){
            $currentBtn.attr('disabled', 'disabled')
            const buttonLoading = setInterval(()=>{
                if(!$button.hasClass('tee-processing')){
                    clearInterval(buttonLoading)
                    window.location.href = '/cart'
                }
            },500)
        }
    }
    $('.upsell-quantity-button').click(function (e) {
        e.preventDefault()
        let currentCart = parseInt($(this).attr('data-cart')),
            qtyInput = parseInt($('[name="quantity"]').val()),
            dataAdd = parseInt($(this).attr('data-quanity'));
        if (qtyInput < dataAdd - currentCart) {
            for (let i = 1; i < dataAdd - currentCart; i++) {
                setTimeout(() => {
                    $('.tee-quantity-plus').click()
                }, 50)
            }
            setTimeout(() => {
                $('#teeAtcButton').click()
                setTimeout(() => {
                    waitATC($(this))
                }, 100)
            }, 250)
        } else {
            setTimeout(() => {
                $('#teeAtcButton').click()
                setTimeout(() => {
                    waitATC($(this))
                }, 100)
            }, 250)
        }

    })

    $('.cart__qty-change').click(function (){
        let $input = $(this).parent().find('.cart__qty-input'),
            currentQty = parseInt($input.val())
        if($(this).hasClass('cart__qty-minus') && currentQty > 1){
            $input.val(currentQty - 1)
        }else{
            $input.val(currentQty + 1)
        }
    })
})